<template>
    <div class="container">
        <nav class="navbar-container">
            <div class="navbar">
                <h1 class="navbar-logo">
                    <img alt="logo" src="@/assets/img/homes/logo.png" class="navbar-logo--img"/>
                    维普培训考试服务平台
                </h1>
                <router-link to="/home-exam" active-class="is--active" class="navbar-item">
                    考试平台
                </router-link>
                <router-link to="/home-business" active-class="is--active" class="navbar-item">
                    行业方案
                </router-link>
                <router-link to="/home-organization" active-class="is--active" class="navbar-item">
                    机构定制
                </router-link>
                <div class="login-container" v-if="isShowLoginBtn">
                    <span class="pointer" @click.stop="handleLogin">登录</span>
                    <span class="divide">|</span>
                    <span class="pointer" @click.stop="handleLogin">注册</span>
                </div>
            </div>
        </nav>
        <login-diolog :show.sync="loginDialogShow"/>
    </div>
</template>

<script>
import { HOME_PAGE_MAP } from "@/utils/platform-config";

export default {
    name: "NavBar",
    computed: {
        // 是佛显示登录按钮
        isShowLoginBtn () {
            const path = this.$route.path
            return ["/home-exam"].includes(path) && HOME_PAGE_MAP[this.$store.state.platform].path === path
        }
    },
    data() {
        return {
            loginDialogShow: false
        }
    },
    created() {
        this.$bus.$on("pc-login-success", this.handleLoginSuccess)
    },
    methods: {
        handleLogin () {
            this.loginDialogShow = true
        },
        handleLoginSuccess () {
            this.$router.replace("/")
        }
    },
    beforeDestroy() {
        this.$bus.$off("pc-login-success", this.handleLoginSuccess)
    }
}
</script>

<style scoped lang="less">
.navbar-container {
    height: 70px;
    box-sizing: border-box;
    position: relative;
    z-index: 9;
}

.navbar {
    height: 70px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    box-sizing: border-box;
    padding-left: 100px;
    padding-right: 190px;
    background-color: #fff;
    display: flex;
    align-items: center;

    &-logo {
        font-size: 26px;

        &--img {
            width: 70px;
            height: 35px;
            vertical-align: middle;
            margin-right: 10px;
        }

        & h1 {
            margin: 0;
            padding: 0;
        }
    }
}

.navbar-item {
    font-size: 16px;
    margin-left: 40px;
    position: relative;
    transition: .2s;

    &.is--active {
        color: #D43422;
        font-weight: 600;

        &::after {
            content: "";
            position: absolute;
            bottom: -14px;
            left: 0;
            right: 0;
            height: 5px;
            background-color: #D43422;
            margin-top: 10px;
        }
    }
}

.login-container {
    margin-left: auto;
    font-size: 16px;

    .divide {
        margin: 0 10px;
    }
}

</style>
